import I18n from 'I18n';
import { I18nLookup } from 'pricing-pages-lib/utils/languageUtils';
import { BREEZE_PRODUCTS, HUBSPOT_CREDITS } from 'self-service-api/constants/ProductCategories';
import { billingNameKeySelector, productSelector } from '../selectors/ProductsSelectors';

/**
 * Processes a list of API names to filter and transform into add-ons with titles
 */
export const getAddOnsFromApiNamesWithTranslations = (state, combinedList = [], searchTerm = '') => {
  // if the combined list is empty, return an empty array
  if (!combinedList || !combinedList.length) {
    return {
      filteredAddOns: [],
      totalAddOns: 0
    };
  }

  // filter and transform into add-ons with titles
  const allAddOns = combinedList.reduce((acc, apiName) => {
    var _product$currentVersi, _product$productCateg, _product$productCateg2;
    const product = productSelector(state, {
      apiName
    });
    const skuId = product === null || product === void 0 || (_product$currentVersi = product.currentVersion) === null || _product$currentVersi === void 0 ? void 0 : _product$currentVersi.skuId;
    const isBreezeProduct = (product === null || product === void 0 || (_product$productCateg = product.productCategory) === null || _product$productCateg === void 0 ? void 0 : _product$productCateg.name) === BREEZE_PRODUCTS;
    const isHubSpotCredits = (product === null || product === void 0 || (_product$productCateg2 = product.productCategory) === null || _product$productCateg2 === void 0 ? void 0 : _product$productCateg2.name) === HUBSPOT_CREDITS;
    if (!skuId) {
      return acc;
    }
    const billingNameKey = billingNameKeySelector(state, {
      skuId
    });
    const i18nKey = `pricing-pages-ui.productNamesV2.${billingNameKey}.title`;
    const translationExists = I18nLookup(i18nKey);

    // if the translation doesn't exist, don't add it to the list
    if (!translationExists) {
      return acc;
    }
    const title = I18n.text(i18nKey);
    acc.push({
      apiName,
      skuId,
      title,
      isBreezeProduct,
      isHubSpotCredits
    });
    return acc;
  }, []);

  // if there is a search term, filter the add-ons by the search term againts the title
  const filtered = allAddOns
  // Apply search term filter if provided
  .filter(({
    title
  }) => !searchTerm || title.toLowerCase().includes(searchTerm.toLowerCase()));
  return {
    filteredAddOns: filtered,
    totalAddOns: allAddOns.length
  };
};